export default "__VITE_ASSET__CbiaFVoi__"